import { Link as RouterLink } from 'react-router-dom';
import { Box, Button, Container, Typography } from '@material-ui/core';
import { EmojiSadOutlined as EmojiSadIcon } from '../icons/emoji-sad-outlined';

export const NotFound = () => (
  <>
    <main className="bg-color">
      <div>
        <img src="/img/error404.png" className="error-img" alt="" />
      </div>
      <div className="text-center" >
        <a href="">
          <button className="rubik weight-500 f-24 error-btn">Back to main page</button>
        </a>
      </div>
    </main>
  </>
);
